import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(request: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Ingredient/AddUnitWeight`;
	return axios.patch(url, request).toOptionalVoid();
}

interface Request {
	ingredientId: string;
	unitId: string;
	weight: number;
}
